/**
 * Said before a place or a folder leaves the knowledge base from its settings. Its documents are
 * what every member with access searches, not only the person saving, and the way back is a full index
 * from the start — so the switch alone does not remove it, the second Save does.
 */
export const KNOWLEDGE_OFF_WARNING =
  "Its documents leave this workspace's knowledge base for everyone here. Turning it back on indexes it again from the start.";

/** The Save button's label once the warning is showing. */
export const KNOWLEDGE_OFF_CONFIRM = 'Remove from knowledge and save';
